/** Blob → `Uint8Array` glue (jsPDF `addImage`, upload payloads, …). */
export async function blobToUint8Array(blob: Blob): Promise<Uint8Array> {
  return new Uint8Array(await blob.arrayBuffer());
}
